<span class="badge badge-pill {{ status ? styles[status] : '' }}">{{ status ? (('transactionStatus.'+status) | translate) : ''}}</span>
